var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "result" }, [
    _c("div", { staticClass: "image herobox-new" }, [
      _c("div", { staticClass: "img-responsive" }, [
        _c("a", { attrs: { href: _vm.resultUrl } }, [
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _vm.result.cruises[0].route.images.length > 0
                ? _c("product-image", {
                    staticClass: "img-responsive image-result",
                    attrs: {
                      image:
                        _vm.result.cruises[0].route.images[
                          _vm.result.cruises[0].route.images.length === 1
                            ? 0
                            : 1
                        ],
                      width: 500,
                      height: 300
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "arrow-up",
                class: { routeoffer: _vm.offers.length }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.offers.length
          ? _c("div", { key: _vm.offers[0].id, staticClass: "route-offer" }, [
              _vm._v(_vm._s(_vm.offers[0].name))
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("h4", [
        _c("strong", [_vm._v(_vm._s(_vm.result.cruises[0].route.name))])
      ]),
      _vm._v(" "),
      _c("div", {
        domProps: {
          innerHTML: _vm._s(_vm.result.cruises[0].route.shortDescription)
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-6" }, [
          _vm._v("\n\t\t\t\tRegion"),
          _c("br"),
          _vm._v(" "),
          _c("strong", [
            _vm._v(_vm._s(_vm.result.cruises[0].route.region.name))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-6" }, [
          _vm._v("\n\t\t\t\tShips"),
          _c("br"),
          _vm._v(" "),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.result.cruises
                  .map(function(cruise) {
                    return cruise.ship.name
                  })
                  .join(", ")
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _vm._v("\n\t\t\t\tDeparture Dates"),
          _c("br"),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.departures.join(", ")))])
        ])
      ]),
      _vm._v(" "),
      Math.round(_vm.minimumPrice)
        ? _c("div", { staticClass: "price" }, [
            _vm._v(
              "\n\t\t\tFrom £" +
                _vm._s(_vm.formatNumber(Math.round(_vm.minimumPrice))) +
                " pp\n\t\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            staticClass: "btn btn-brand",
            staticStyle: { "max-width": "fit-content" },
            attrs: { href: _vm.resultUrl }
          },
          [_vm._v("VIEW MORE")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }